<template>
  <div>
    <van-nav-bar
      title="历史操盘"
      left-arrow
      @click-left="$router.push('capital_account?activeTab=2')"

    />
    <div style="padding: 15px; font-size: 14px;">
      <van-row>
        <van-col span="12"><span>合同编号</span></van-col>
        <van-col span="12" style="text-align: right"
          ><span>{{ order }}</span></van-col
        >
      </van-row>
      <van-row style="padding-top: 30px; text-align: center">
        <van-col span="24"
          ><span>{{ name }}</span></van-col
        >
        <van-col span="24" style="color: #828283"
          ><span>{{ time }}</span></van-col
        >
      </van-row>
      <van-row style="padding-top: 15px; text-align: center">
        <van-col span="8"></van-col>
        <van-col span="8"
          ><van-row style="margin-top: 20px">
            <van-circle
              v-model="proportion"
              :speed="100"
              :rate="0"
              layer-color="#ebedf0"
              :text="text" /></van-row
        ></van-col>
        <van-col span="8"></van-col>
      </van-row>
      <van-row class="profitLoss">
        <van-col span="24"><span>交易盈亏</span></van-col>
        <van-col span="24" style="color: #828283"
          ><span v-bind:class="[profit > 0 ? 'redText' : 'greenText']">{{
            profit>0?profit:loss
          }}</span>
        </van-col>
      </van-row>

      <van-row class="topBottom">
        <van-col span="12"><span>总操盘资金</span></van-col>
        <van-col span="12" style="text-align: right"
          ><span>{{ total }}</span></van-col
        >
      </van-row>
      <van-row class="topBottom" style="border-bottom: 1px solid #c8c9cc">
        <van-col span="12"><span>管理费</span></van-col>
        <van-col span="12" style="text-align: right"
          ><span>{{ manage }}</span></van-col
        >
      </van-row>
      <van-row style="padding-top: 15px; padding-bottom: 15px">
        <van-col span="12"><span>交易品种</span></van-col>
        <van-col span="12" style="text-align: right"
          ><span>{{ type }}</span></van-col
        >
      </van-row>

      <van-row class="rowDesign">
        <van-col span="8" class="columnDesign">
          <van-row class="topValue"><span>总策略资金</span> </van-row>
          <van-row class="topValue"
            ><span style="color: #000000">{{ total }}</span>
          </van-row>
        </van-col>
        <van-col span="8" class="columnDesign">
          <van-row class="topValue"><span>申请额度</span> </van-row>
          <van-row class="topValue"
            ><span style="color: #000000">{{ apply_quota }}</span>
          </van-row>
        </van-col>
        <van-col span="8" class="columnDesign" style="background: none">
          <van-row class="topValue"><span>风险保证金</span> </van-row>
          <van-row class="topValue"
            ><span style="color: #000000">{{ bond }}</span>
          </van-row>
        </van-col>
      </van-row>

      <van-row class="rowDesign">
        <van-col span="8" class="columnDesign">
          <van-row class="topValue"><span>收益分成</span> </van-row>
          <van-row class="topValue"
            ><span style="color: #000000">{{ divided }}</span>
          </van-row>
        </van-col>
        <van-col span="8" class="columnDesign">
          <van-row class="topValue"><span>亏损警戒线</span> </van-row>
          <van-row class="topValue"
            ><span style="color: #000000">{{ warning }}</span>
          </van-row>
        </van-col>
        <van-col span="8" class="columnDesign" style="background: none">
          <van-row class="topValue"><span>亏损平仓线</span> </van-row>
          <van-row class="topValue"
            ><span style="color: #000000">{{ close }}</span>
          </van-row>
        </van-col>
      </van-row>

      <van-row style="padding-top: 15px">
        <van-col span="24"><span>交易盈亏分配</span></van-col>
      </van-row>

      <van-row class="topBottom">
        <van-col span="12"><span>盈利分配</span></van-col>
        <van-col span="12" style="text-align: right">
          <span v-bind:class="[profit >= 0 ? 'redText' : 'greenText']">{{
            profit
          }}</span>
        </van-col>
      </van-row>

      <van-row class="topBottom">
        <van-col span="12"><span>亏损赔付</span></van-col>
        <van-col span="12" style="text-align: right"
          ><span v-bind:class="[loss >= 0 ? 'redText' : 'greenText']">{{
            loss
          }}</span></van-col
        >
      </van-row>

      <van-row style="padding-top: 15px">
        <van-col span="24"><span>保证金结算</span></van-col>
      </van-row>

      <van-row class="topBottom">
        <van-col span="12"><span>冻结</span></van-col>
        <van-col span="12" style="text-align: right"
          ><span v-bind:class="[bond >= 0 ? 'redText' : 'greenText']">{{
            bond
          }}</span></van-col
        >
      </van-row>

      <van-row class="topBottom">
        <van-col span="12"><span>扣减</span></van-col>
        <van-col span="12" style="text-align: right"
          ><span v-bind:class="[deduction >= 0 ? 'redText' : 'greenText']">{{
            deduction
          }}</span></van-col
        >
      </van-row>

      <van-row class="topBottom">
        <van-col span="12"><span>解冻</span></van-col>
        <van-col span="12" style="text-align: right"
          ><span>{{ thaw }}</span></van-col
        >
      </van-row>
      <router-link to="/fund_details">
        <van-row style="padding-top: 15px">
          <van-col span="24"
            ><span style="color: #1989fa"
              >交易流水(点击查看更多明细)</span
            ></van-col
          >
        </van-row>
      </router-link>

      <!-- ============================== -->
      <van-row style="padding: 10px 0px; text-align: center">
        <van-col span="6" style="text-align: left"
          ><span>名称代码</span></van-col
        >
        <van-col span="6"><span>价格/数量</span></van-col>
        <van-col span="6"><span>买卖/状态</span></van-col>
        <van-col span="6" style="text-align: right"
          ><span>成交时间</span></van-col
        >
      </van-row>
      <div v-for="(item, index) in trade" :key="index">
        <van-row style="padding-bottom: 10px; text-align: center">
          <van-col span="6" style="text-align: left"
            ><span>{{ item.name }}<br /></span
            ><span>{{ item.code }}</span></van-col
          >
          <van-col span="6"
            ><span>{{ item.price }}<br /></span
            ><span>{{ item.number }}</span></van-col
          >
          <van-col span="6"
            ><span>{{ item.type }}<br /></span
            ><span>{{ item.status }}</span></van-col
          >
          <van-col span="6" style="text-align: right"
            ><span>{{ item.time }}<br /></span
            ><span>{{ item.accurate }}</span></van-col
          >
        </van-row>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "ClosedCapitalInfo",
  data() {
    return {
      name: "", //策略名称
      order: "", //策略单号
      time: "", //策略时间
      proportion: 0, //盈亏比例
      profit: "", //盈利金额
      loss: "", //亏损金额
      deduction: "", //扣除数量
      thaw: "", //解冻数量
      total: "", //总策略资金
      manage: "", //管理费
      type: "", //交易品种
      capital_total: "", //策略金额
      apply_quota: "", //申请金额
      bond: "", //保证金
      divided: "", //盈利分配
      warning: "", //预警线
      close: "", //平仓线
      trade: [], //交易记录
      capitalState: false,
      capitalData: [],
    };
  },
  mounted: function () {
    this.getInfo();
  },
  computed: {
    text() {
      return "盈亏比例 " + this.proportion + "%";
    },
  },
  methods: {
    getInfo() {
      let that = this;
      that
        .$http({
          url: "/",
          method: "post",
          data: {
            nozzle: "history_detailed",
            token: sessionStorage.getItem("token"),
            cid: sessionStorage.getItem("cid"),
          },
        })
        .then(function (res) {
          if (res.data.code == 1) {
            that.name = res.data.data.info.name;
            that.order = res.data.data.info.order;
            that.time = res.data.data.info.time;
            that.proportion = parseFloat(res.data.data.info.proportion);
            that.profit = res.data.data.info.profit;
            that.deduction = res.data.data.info.deduction;
            that.total = res.data.data.info.total;
            that.manage = res.data.data.info.manage;
            that.type = res.data.data.info.type;
            that.capital_total = res.data.data.info.capital_total;
            that.apply_quota = res.data.data.info.apply_quota;
            that.bond = res.data.data.info.bond;
            that.divided = res.data.data.info.divided;
            that.warning = res.data.data.info.warning;
            that.close = res.data.data.info.close;
            that.loss = res.data.data.info.loss;
            that.thaw = res.data.data.info.thaw;
            that.trade = res.data.data.trade;
          } else if (res.data.code == 0) {
            that.$toast.fail(res.data.msg);
          }
        });
    },
    getCapitalData() {
      let that = this;
      that
        .$http({
          url: "/",
          method: "post",
          data: {
            nozzle: "capital_log",
            token: window.sessionStorage.getItem("token"),
            cid: sessionStorage.getItem("cid"),
          },
        })
        .then((res) => {
          if (res.data.code == 1) {
            that.capitalData = res.data.data;
            that.capitalState = true;
          } else if (res.data.code == 0 || res.data.code == -1) {
            that.$toast.fail(res.data.msg);
          }
        });
    },
  },
};
</script>

<style scoped>
.navStyles {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
}
.rowDesign {
  text-align: center;
  line-height: 10px;
  padding-top: 5px;
}

.columnDesign {
  height: 60px;
  line-height: 60px;
  background: #ffffff;
  background: url(../assets/images/line.png) right no-repeat;
  background-size: 1px 45px;
}

.topValue {
  text-align: center;
  line-height: 10px;
  padding-top: 14px;
}

.tableheading {
  font-size: 14px;
  height: 30px;
  line-height: 30px;
  padding-bottom: 14px;
  border-bottom: 1px solid #dcdee0;
  text-align: center;
  padding-top: 14px;
  color: #ff3334;
}

.tablecontent {
  font-size: 14px;
  height: 40px;
  line-height: 20px;
  padding-bottom: 8px;
  border-bottom: 1px solid #dcdee0;
  text-align: center;
  padding-top: 8px;
}

.optionList {
  text-align: center;
  position: fixed;
  bottom: 50px;
  width: 100%;
  height: 60px;
  line-height: 40px;
  background: #ffffff;
}

.profitLoss {
  padding-top: 16px;
  padding-bottom: 16px;
  text-align: center;
  border-bottom: 1px solid #c8c9cc;
}

.topBottom {
  padding-top: 10px;
  padding-bottom: 10px;
  border-bottom: 1px solid #dcdee0;
}

.redText {
  color: red;
}
.greenText {
  color: green;
}
</style>




// WEBPACK FOOTER //
// src/components/ClosedCapitalInfo.vue